import store from '@/store'

// 定位
async function getLocation() {
  if (store.getters.location.city === '') {
    await store
      .dispatch('location/getLocation')
      .catch(err => {
        console.log(err)
      })
    // return result
  }
}

// 获取用户积分
async function getUsersurplus(to, from) {
  if (to.meta.isGetUserSurplus) {
    store.dispatch('user/getUsersurplus')
  }
}
// 获取用户信息
async function getUserInfo() {
  if (Object.keys(store.getters.userInfo).length === 0) {
    await store.dispatch('user/getUserInfo')
  }
}
// 获取用户福利卡
async function getWelfareCards() {
  if (store.getters.welfareCards.length === 0) {
    await store.dispatch('user/getBalanceList')
  }
}
const locationPass = ['/paymentCashier', '/payOrderStatus']

const fetchUserData = async (to, from) => {
  // 获取用户信息
  // if (
  //   !locationPass.includes(to.path)
  // ) {
  //    await getLocation()
  // }

  // 获取用户积分
  await getUsersurplus(to, from)
  // 获取用户信息
  await getUserInfo()
  // 获取用户福利卡
  // await getWelfareCards()
}

export default fetchUserData
